enum WorkspaceProjectAiReportAssistantSubsectionQuestionType {
  generic = 'generic',
  project = 'project',
}

export default WorkspaceProjectAiReportAssistantSubsectionQuestionType
